// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1Y-2L","label":"Section_label__20cuR","contentWrap":"Section_contentWrap__-tD01","footer":"Section_footer__2vlO7","footerInner":"Section_footerInner__1O2IZ"};